import { forwardRef } from 'react';
import { UiComponent } from '../../types/ui-component';
import { ChildrenProps, classNames } from '@cotera/client/app/components/utils';

type SpanProps = UiComponent &
  ChildrenProps &
  React.HTMLAttributes<HTMLSpanElement>;

export const Span = forwardRef<HTMLSpanElement, SpanProps>(
  ({ className, ...props }, ref) => {
    return (
      <span
        ref={ref}
        {...props}
        className={classNames('text-foreground', 'text-sm', className)}
      />
    );
  }
);
